'use client';

import {useState} from 'react';
import {algoliasearch} from 'algoliasearch';

import {dataset} from '@/sanity/lib/api';

type AlgoliaHits = {
	objectID: string;
};

export const ALGOLIA_HITS_PER_PAGE = 7;

const client = algoliasearch(
	process.env.NEXT_PUBLIC_ALGOLIA_APP_ID ?? '',
	process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY ?? '',
);

export const useAlgoliaSearch = (query: string, page: number) => {
	const [algoliaHits, setAlgoliaHits] = useState<AlgoliaHits[]>([]);
	const [totalHits, setTotalHits] = useState<number | undefined>(undefined);
	const [loadingAlgoliaFetch, setLoadingAlgoliaFetch] = useState(false);
	const [algoliaError, setAlgoliaError] = useState<string | null>(null);

	const fetchAlgoliaResults = async () => {
		setLoadingAlgoliaFetch(true);
		try {
			const response = await client.searchSingleIndex<AlgoliaHits>({
				indexName: dataset,
				searchParams: {
					query,
					hitsPerPage: ALGOLIA_HITS_PER_PAGE,
					page: page - 1,
					attributesToRetrieve: ['objectID'],
				},
			});

			const algoliaHits = response.hits;
			const algoliaTotalHits = response.nbHits ?? 0;

			setAlgoliaHits(algoliaHits);
			setTotalHits(algoliaTotalHits);
			setLoadingAlgoliaFetch(false);
		} catch (error) {
			console.error(error);
			setAlgoliaError('Feil ved henting av søkeresultater');
		}
	};

	const algoliaIds = algoliaHits.map((hit) => hit.objectID);

	return {
		fetchAlgoliaResults,
		totalHits,
		loadingAlgoliaFetch,
		algoliaIds,
		algoliaError,
	};
};
